/** @jsxImportSource @emotion/react */
import React from 'react'
import {OffersForm, OffersPreview} from '../../../components/templates'
import * as styles from '../index.styles'
import Provider from '../../../context/OffersContext'
import { breadcrumbItems } from '../../utils'
import { Breadcrumb } from '../../../components/atoms'

const { index, contentManagement, manageOffers } = breadcrumbItems

const CreateOffers: React.FC = () => {
  return (
    <Provider>
      <Breadcrumb items={[index, contentManagement, manageOffers]} />
      <div css={styles.root}>
        <div css={styles.main}>
          <OffersForm />
        </div>
        <div css={styles.right}>
          <OffersPreview />
        </div>
      </div>
    </Provider>
  )
}

export default CreateOffers
